import {useEffect,useRef} from 'react';
import {useBlocker} from 'react-router-dom';
import {useRegisterRoleNavigationGuard} from '@/layout/AppLayout';
/** An uncertain admitted request retains its exact request ID until replay is
 * resolved. Reuses the shell guard; no new modal or patient storage. */
export function usePendingReceptionPlan(blocked:boolean,onBlocked:()=>void) {
 const current=useRef({blocked,onBlocked});current.current={blocked,onBlocked};
 const register=useRegisterRoleNavigationGuard();
 useEffect(()=>register(async()=>{if(current.current.blocked){current.current.onBlocked();return false;}return true;}),[register]);
 const navigation=useBlocker(()=>current.current.blocked);
 useEffect(()=>{if(navigation.state==='blocked'){current.current.onBlocked();navigation.reset();}},[navigation]);
 useEffect(()=>{const leave=(event:BeforeUnloadEvent)=>{if(current.current.blocked){event.preventDefault();event.returnValue='';}};window.addEventListener('beforeunload',leave);return()=>window.removeEventListener('beforeunload',leave);},[]);
}
